/**
 * Decorator function that requires class property to be required.
 *
 * @param target The class's prototype.
 * @param prop Property name that is being decorated.
 */
export function isRequired(target: any, prop: string) {
  const NG_ON_ONIT_NAME = 'ngOnInit';

  /** ngOnInit might not be implemented by this component */
  const ngOnInitClone: Function | null = target[NG_ON_ONIT_NAME];

  Object.defineProperty(target, NG_ON_ONIT_NAME, {
    value() {
      if (this[prop] == null) {
        console.warn(`${target.constructor.name}: ${prop} is required, but was not provided`);
      }
      // Calling the original ngOnInit with its original context:
      if (ngOnInitClone) {
        ngOnInitClone.call(this);
      }
    },
  });
}
